import { render, staticRenderFns } from "./ScreeningCustomersTable.vue?vue&type=template&id=6fe33202&scoped=true"
import script from "./ScreeningCustomersTable.vue?vue&type=script&lang=ts"
export * from "./ScreeningCustomersTable.vue?vue&type=script&lang=ts"
import style0 from "./ScreeningCustomersTable.vue?vue&type=style&index=0&id=6fe33202&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe33202",
  null
  
)

export default component.exports